import React from 'react'
import { getImageUrl } from '../utils/image'
import s from './GeoentityCardTransportInfo.less'

export default function GeoentityCardTransportInfo({ transportInfo }) {
  if (!transportInfo) return null

  return (
    <ul className={s.list}>
      {transportInfo.map(({ mode, lines }, idx) => (
        <li key={idx} className={s.item}>
          <img className={s.img} key={mode} src={getImageUrl(mode)} />
          {lines && lines.map(line => <img className={s.img} key={line} src={getImageUrl(line)} />)}
        </li>
      ))}
    </ul>
  )
}
